/**
 * CNPJ da UI (02/09/2026 — cadastro completo de tomadores): normalização,
 * validação de DV (módulo 11) para erro rápido no formulário (a validação
 * real e final é SEMPRE do servidor) e formatação para exibição/digitação.
 *
 * DUPLICAÇÃO CONSCIENTE de api/cnpj.ts (MESMO algoritmo): a UI não importa
 * código do backend. Mudanças devem ser espelhadas nos dois lados — os testes
 * puros (web/src/cnpj.test.ts e api/cnpj.test.ts) cobrem o mesmo conjunto.
 */

/** 14 dígitos com DV válido, ou null. Rejeita tamanho errado e dígitos
 *  repetidos ("00000000000000", …), que passariam no módulo 11. */
export function normalizarCnpj(valor: unknown): string | null {
  if (typeof valor !== "string") return null;
  const d = valor.replace(/\D/g, "");
  if (d.length !== 14) return null;
  if (/^(\d)\1{13}$/.test(d)) return null;
  if (digitoVerificador(d.slice(0, 12)) !== Number(d[12])) return null;
  if (digitoVerificador(d.slice(0, 13)) !== Number(d[13])) return null;
  return d;
}

/** DV módulo 11 do CNPJ: pesos 2..9 da direita para a esquerda (ciclando). */
function digitoVerificador(base: string): number {
  let soma = 0;
  let peso = 2;
  for (let i = base.length - 1; i >= 0; i--) {
    soma += Number(base[i]) * peso;
    peso = peso === 9 ? 2 : peso + 1;
  }
  const resto = soma % 11;
  return resto < 2 ? 0 : 11 - resto;
}

/** "11222333000181" → "11.222.333/0001-81" (entrada fora de 14 dígitos volta
 *  como veio — a formatação é só cosmética). */
export function formatarCnpj(digitos: string): string {
  const d = digitos.replace(/\D/g, "");
  if (d.length !== 14) return digitos;
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}`;
}
